const formatMoney = (amount, decimalCount = 2, decimal = '.', thousands = ',') => {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = Number.isNaN(Number(decimalCount)) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? '-' : '';

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount), 10).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '');
    } catch (e) {
        console.log(e);
        return 0.00;
    }
};

/**
 * @param {CurrencyService} currencyService
 * @param {Number} input
 * @param {Number} [decimalCount]
 * @returns {string}
 */
const formatCurrency = (currencyService, input, decimalCount = 2) => {
    return currencyService.getSymbol() + formatMoney(input, decimalCount);
};

module.exports = {
    formatCurrency,
    formatMoney,
};
